export default "__VITE_ASSET__20cdfd6a__"